import { Property, SelectField } from '@/components/form/fields/select/SelectInput';
import { TextField } from '@/components/form/fields/text/TextInput';
import { useRegions } from '@/services/api/hooks/region';
import { FunctionComponent } from 'react';
import AddressField from '../../../components/form/fields/address/AddressField';

interface BusinessStepProps {
  region?: boolean;
  readonly?: boolean;
}

const BusinessStep: FunctionComponent<BusinessStepProps> = ({ region, readonly }) => {
  const [regions] = useRegions();

  const regionOptions: Property[] = regions.map(r => ({ id: r.id, name: r.name }));

  return (
    <div className="flex flex-col space-y-2">
      {readonly && (
        <div>Please check these details. If anything is incorrect, please contact your MSP to change them.</div>
      )}
      <div className="flex flex-row space-x-5">
        <TextField className="flex-1" id="companyInfo.name" label="Company name" readonly={readonly} />
        <TextField id="companyInfo.number" label="Registered company number" readonly={readonly} />
      </div>
      {region && (
        <SelectField
          id="region"
          label="Region"
          options={regionOptions}
          placeholder="Please Select"
          readonly={readonly}
        />
      )}
      <AddressField fieldKey="companyInfo" readonly={readonly} />
    </div>
  );
};

export default BusinessStep;
